<template>
    <div :class="stylePanel">
        <CompassPanel
            :ref="refPanel"
            v-model="showPanel"
            size="large"
            :title="email.subject"
            icon="obj-slsy-sent-email"
            enableShrink
            @toggled="toggleState"
            @closed="closePanel"
        >
            <template slot>
                <div v-show="!isPanelMinimized" class="email-panel__content">
                    <CompassAlert
                        v-if="email.status === 'failed_to_send'"
                        type="error"
                        :description="
                            $t.__('email.emailPreviewPanel.description_alert_failed_email')
                        "
                        :showClose="false"
                        :action="getActionAlert"
                    />
                    <EmailPreviewPanelContent :email="email" :thread="thread" />
                </div>
            </template>
            <template v-if="email.status === 'failed_to_send'" slot="footer">
                <div v-if="!isPanelMinimized" class="email-panel__footer">
                    <div class="compass-panel__footer--default">
                        <CompassButton
                            :label="$t.__('common.actions.delete')"
                            type="secondary"
                            :disabled="isLoadingButtonResend"
                            @click="handleDelete"
                        />
                        <CompassButton
                            :label="$t.__('email.emailPreviewPanel.action_resend')"
                            :loading="isLoadingButtonResend"
                            @click="handleResend"
                        />
                    </div>
                </div>
            </template>
        </CompassPanel>
    </div>
</template>
<script>
import Feature from 'Services/Feature';
import EmailPreviewPanelContent from 'vcomponents/email/emailPanels/emailPreviewPanel/EmailPreviewPanelContent.vue';
import { resendFailedEmailById } from 'api/emailEngine/emailEngineService';

import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        EmailPreviewPanelContent,
    },
    props: {
        email: {
            type: Object,
            required: true,
        },
        hashPanel: {
            type: String,
            required: true,
        },
        isPanelMinimized: {
            type: Boolean,
            default: false,
        },
        thread: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            refPanel: null,
            showPanel: false,
            isLoadingButtonResend: false,
        };
    },
    computed: {
        stylePanel() {
            return ['email-panel', { minimized: this.isPanelMinimized }];
        },
        getActionAlert() {
            return {
                label: this.$t.__('common.labels.contact_support'),
                callback: () => this.handleContactUs(),
            };
        },
    },
    watch: {
        isPanelMinimized(newValue) {
            this.$nextTick(() => {
                this.$refs[`${this.refPanel}`].isMinimized = newValue;
            });
        },
    },
    created() {
        this.refPanel = `refPanel-${this.hashPanel}`;
        this.showPanel = true;
        this.manageMinimize();
    },
    mounted() {
        this.manageMinimize();
    },
    methods: {
        ...popupPanelMapActions(['open']),
        manageMinimize() {
            if (this.isPanelMinimized) {
                this.$nextTick(() => {
                    this.$refs[`${this.refPanel}`].isMinimized = true;
                });
            }
        },
        toggleState() {
            this.$emit('toggle-panel-state');
        },
        closePanel() {
            this.$emit('close-panel');
            this.showPanel = false;
        },
        handleResend() {
            this.isLoadingButtonResend = true;
            resendFailedEmailById(this.email.id)
                .then(() => {
                    this.$pushToast({
                        close: true,
                        text: this.$t.__('email.EmailPreviewPanel.email_resent'),
                        type: 'success',
                    });
                    EventBus.$emit('refreshOutBoxEmailListing');
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.isLoadingButtonResend = false;
                    this.closePanel();
                });
        },
        handleDelete() {
            this.open({
                key: 'emailDeleteConfirmDialog',
                props: {
                    email: this.email,
                },
            });
            this.closePanel();
        },
        handleContactUs() {
            if (Feature.isEnabled('intercom')) {
                window.Intercom('show');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.email-panel {
    &::v-deep .compass-alert__text-container {
        white-space: pre-line;
    }

    &__footer {
        padding-bottom: 0;

        .compass-panel__footer--default {
            flex-direction: row;
            justify-content: flex-end;
        }
    }
}
</style>
